<template>
  <div :class="style.header" id="headerBlock">
    <ActionGradientComponent :isEditHeader="true" />
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import style from "./HeaderContactsComponent.module.scss";
import ActionGradientComponent from "@/page/quiz/view/components/sections/components/ActionGradient/ActionGradientComponent.vue";

export default defineComponent({
  name: "HeaderContactsComponent",
  components: {ActionGradientComponent},
  data() {
    return {
      style
    };
  }
});
</script>
